import React from "react";
import searchicon from "../../Assets/Icons/akar-icons_search.svg";

const SearchBar = ({
  parentDivClass,
  divClassName,
  inputClassName,
  iconClassName,
  placeholder,
  value,
  handleChange,
  handleKeyDown,
  onBlur,
  searchResults,
  handleResultClick,
  resultsVisible = false,
  noResultsText = "No results found",
  onIconClick,
}) => {
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        if (onBlur) onBlur();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onBlur]);

  return (
    <div className={parentDivClass} ref={containerRef}>
      <div className={divClassName}>
        <input
          type="text"
          value={value}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          // onBlur={onBlur} // Handled by click-outside now
          placeholder={placeholder}
          className={inputClassName}
        />
        <img
          className={iconClassName + " cursor-pointer"}
          src={searchicon}
          onClick={onIconClick}
          alt="search"
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && typeof onIconClick === 'function') onIconClick();
          }}
        />
      </div>
      {resultsVisible && (
        <div
          className="absolute top-full left-0 right-0 max-h-[200px] rounded-[5px] mt-1 bg-white border border-gray-200 shadow-lg overflow-y-auto z-50"
          style={{ scrollbarWidth: "thin" }} // Changed to thin for better UX while scrolling
        >
          {Array.isArray(searchResults) && searchResults.length > 0 ? (
            searchResults.map((result, index) => (
              <div
                key={result.id || index}
                onClick={() => handleResultClick(result)}
                className="group cursor-pointer font-poppins font-[400] text-[14px] px-3 py-2 border-b border-gray-100 last:border-b-0 transition-all duration-150 ease-in-out hover:bg-[#E6F7FB] hover:text-[#007EA7] hover:shadow-sm hover:ring-1 hover:ring-[#00ADEF]/40 focus-within:ring-1 focus-within:ring-[#00ADEF]/60 active:bg-[#D9F2FB] rounded-[6px]"
              >
                <div className="flex flex-col">
                  <div className="font-medium text-[#303030] transition-colors duration-150 group-hover:text-[#007EA7]">
                    {result.title}
                  </div>
                  <div className="text-xs text-gray-500 transition-colors duration-150 mt-1 group-hover:text-[#0099c8]">
                    {result.description}
                  </div>
                  {result.status && (
                    <div className="text-xs text-gray-400 transition-colors duration-150 mt-1 group-hover:text-[#007EA7]">
                      Status: {result.status}
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="font-poppins text-[13px] text-gray-500 px-3 py-2">{noResultsText}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;
